/*---------------Libraries-----------------*/
import { createContext, useContext } from "react";

/*---------------Stores--------------------*/
import CartStore from "./cartStore";
import CommonStore from "./commonStore";
import CouponStore from "./couponStore";
import CustomerStore from "./customerStore";
import OrderStore from "./orderStore";
import ProductStore from "./productStore";
import UserStore from "./userStore";
import DashboardStore from "./dashboardStore";
import ModalStore from "./modalStore";
import ToasterStore from "./toasterStore";
import QuickDeliveryStore from "./quickDeliveryStore";
import OnboardingStore from "./onboardingStore";
import LocationStore from "./locationStore";

export interface Store {
  cartStore: CartStore;
  commonStore: CommonStore;
  couponStore: CouponStore;
  customerStore: CustomerStore;
  orderStore: OrderStore;
  productStore: ProductStore;
  userStore: UserStore;
  dashboardStore: DashboardStore;
  modalStore: ModalStore;
  toasterStore: ToasterStore;
  quickDeliveryStore: QuickDeliveryStore;
  onboardingStore: OnboardingStore;
  locationStore: LocationStore;
}

export const store = {} as Store;

store.cartStore = new CartStore();
store.commonStore = new CommonStore();
store.couponStore = new CouponStore();
store.customerStore = new CustomerStore();
store.productStore = new ProductStore();
store.userStore = new UserStore();
store.orderStore = new OrderStore(store);
store.dashboardStore = new DashboardStore();
store.modalStore = new ModalStore();
store.toasterStore = new ToasterStore();
store.quickDeliveryStore = new QuickDeliveryStore();
store.onboardingStore = new OnboardingStore();
store.locationStore = new LocationStore();

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
